export default "__VITE_ASSET__2ajvg0wO__"